import {List, Create, Edit, Users} from '../Components'

export default [
    {path: '/admin/pay-allowance', component: List, name: 'pay-allowance-list'},
    {path: '/admin/pay-allowance/:id/edit', component: Edit, name: 'pay-allowance-edit'},
    {path: '/admin/pay-allowance/create', component: Create, name: 'pay-allowance-create'},
    {path: '/admin/pay-allowance/:id/users', component: Users, name: 'pay-allowance-users'},
]